import { render, staticRenderFns } from "./notification-inbox.vue?vue&type=template&id=e2ef3e68&"
import script from "./notification-inbox.vue?vue&type=script&lang=js&"
export * from "./notification-inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports